/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const setHasNudgeActive =
	(hasNudgeActive: boolean, itemName: string | null = ''): Action<State> =>
	({ getState, setState }) => {
		/* Grab current state of is currentHasNudgeActive */
		const { hasNudgeActive: currentHasNudgeActive, openTask } = getState();

		if (hasNudgeActive === currentHasNudgeActive) {
			// if state has not been updated we just return
			return;
		}

		if (hasNudgeActive === false && itemName !== openTask) {
			// do not update a nudge if the current open task is different than the one we called the function with
			return;
		}

		setState({ hasNudgeActive });
	};

export default setHasNudgeActive;
